/**
 * Volle Lebensjahre am Tag `heute`, gerechnet in Ortszeit.
 *
 * <p>`heute` wird bewusst uebergeben und nie intern `new Date()` gezogen: sonst ist jeder Test dazu
 * eine Zeitbombe, die am naechsten Geburtstag eines Fixtures kippt. Das Backend rechnet dieselbe
 * Frage in `InkoZielgruppe.alterInJahren` genauso (Parameter `heute`).
 *
 * <p>Wer am 29.02. geboren ist, wird in Nicht-Schaltjahren erst am 01.03. ein Jahr aelter, wie bei
 * Javas `Period.between`.
 */
export function alterInJahren(geburtsdatum: Date, heute: Date): number {
  const alter = heute.getFullYear() - geburtsdatum.getFullYear()
  const monatsDifferenz = heute.getMonth() - geburtsdatum.getMonth()
  // Der Geburtstag ist in diesem Jahr noch nicht erreicht.
  if (monatsDifferenz < 0 || (monatsDifferenz === 0 && heute.getDate() < geburtsdatum.getDate())) {
    return alter - 1
  }
  return alter
}
